// extracted by mini-css-extract-plugin
export default {"container":"AdminPageStyles_container__LD3bx","admin-title":"AdminPageStyles_admin-title__Q2Vme","grouped-link":"AdminPageStyles_grouped-link__sqVhi"};